import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig} from "axios";
import {Modal} from "ant-design-vue";
import config from "@/config";
import router from "@/views";
import emit from "@/lib/emit";

export const api: AxiosInstance = axios.create({
    baseURL: config.baseUrl,
    timeout: 50000,
    withCredentials: true,
    responseType: 'json',
} as AxiosRequestConfig)

let timer = 0;

const errHandler = async (err: unknown): Promise<unknown> => {
    if (err instanceof AxiosError) {
        if (err.response !== undefined) {
            console.log('api error:', err.response.status);
            if (err.response.status === 401) emit.emit('session.timeout')
            else if (err.response.status === 403) await router.push({name: 'login'})
            if (err.response.data.error) Modal.error({title:'错误',content: err.response.data.error})
            else if (err.response.data instanceof Blob) err.response.data.text().then((s: string) => Modal.error({title:'错误',content: JSON.parse(s).error}))
            else Modal.error({title:'错误',content:`${err.response.status}`})
        }
    }
    return Promise.reject(err)
}

api.interceptors.request.use((config: InternalAxiosRequestConfig): InternalAxiosRequestConfig<unknown> | Promise<InternalAxiosRequestConfig<unknown>> => config, errHandler)

api.interceptors.response.use((r: AxiosResponse) => {
    if (r.status === 200) {
        if (isNaN(Number(r.headers.etag)) || Number(r.headers.etag) < 60) return Promise.reject('etag required')
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            api({url: 'keepalive'}).catch((err: unknown) => console.error(err))
        }, (Number(r.headers.etag) - 60) * 1000) as unknown as number
    }
    return r.data
}, errHandler)
